import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  AssetConsumptionReportParams,
  AssetConsumptionReportResponse,
  CreateAssetParams,
  CreateAssetResponse,
  EditAssetParams,
  EditAssetResponse,
  FindAssetByIdParams,
  FindAssetByIdResponse,
  SearchAssetsParams,
  SearchAssetsResponse,
} from '../domain/asset'

const ROOT_URL = '/entity/assets'

export const AssetService = {
  search: async (params: SearchAssetsParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<SearchAssetsResponse>(url)
  },

  findById: async ({ id }: FindAssetByIdParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.get<FindAssetByIdResponse>(url)
  },

  consumptionReport: async ({
    id,
    ...params
  }: AssetConsumptionReportParams) => {
    const url =
      ROOT_URL + `/${id}/consumption-report?${querySerializer(params)}`
    return await WitaConnector.get<AssetConsumptionReportResponse>(url)
  },

  create: async (params: CreateAssetParams) => {
    const url = ROOT_URL
    return await WitaConnector.post<CreateAssetResponse>(url, params)
  },

  edit: async ({ id, ...params }: EditAssetParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<EditAssetResponse>(url, params)
  },
}
